import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'vx-ui-components';
import { Flex, Box } from 'reflexbox';
import Growler from '../../containers/Notification';
import { spinner } from 'vx-commons/lib/utils/icons';
import styles from './styles.css';
import {
  selectError,
} from 'vx-commons/lib/selectors';

class RequestPasswordRecovery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      submitted: false,
    };
  }

  handleRequestPasswordRecovery = (e) => {
    const {
      email,
    } = this.state;
    e.preventDefault();
    this.props.submitRequestPasswordRecovery(email);
    this.setState({ submitted: true });
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  render() {
    const { submitted } = this.state;
    const { loginRequired, error} = this.props;

    if(loginRequired && submitted && !error) {
      return spinner();
    }

    return (
      <Flex align="center" className={styles.loginWrap}>
        <Growler />
        <Box className={styles.login}>
          <form onSubmit={this.handleRequestPasswordRecovery} style={{ width: '100%' }}>
            <div className={styles.wrap}>
              <label className={styles.label}>Please, insert your email address in order to reset the password:</label>
              <input
                className={styles.input}
                id="email"
                type="text"
                value={this.state.email}
                onChange={this.handleEmailChange}
                autoFocus
              />
            </div>
            <div style={{ padding: '2em' }}>
              <Button
                label="send"
                icon="send"
                type="submit"
                style={{ width: '100px',display: 'block', margin: '0 auto' }}
              />
            </div>
          </form>
        </Box>
      </Flex>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  error: selectError(),
});

RequestPasswordRecovery.propTypes = {
  submitRequestPasswordRecovery: PropTypes.func,
};

export default connect(
  mapStateToProps
)(RequestPasswordRecovery);




// WEBPACK FOOTER //
// ./src/containers/RequestPasswordRecovery/index.js